import axios from "axios";
import { toast } from "react-toastify";
import superAdminAuthHeader from "./superAdminAuthHeader";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/super-admin/hsn`,
});

const request = (method, url, data, params) =>
  api({ method, url, data, params, headers: superAdminAuthHeader() })
    .then((res) => res.data.data)
    .catch((error) => {
      if (error?.response?.data?.msg) toast.error(error.response.data.msg);
      return Promise.reject(error);
    });

export const getAllSuperAdminHsn = (search = "") =>
  request("get", "/", undefined, { search });

export const getSuperAdminHsn = (id) => request("get", `/${id}`);

export const createSuperAdminHsn = (data) =>
  request("post", "/", data).then((result) => {
    toast.success("HSN record created successfully");
    return result;
  });

export const updateSuperAdminHsn = (id, data) =>
  request("put", `/${id}`, data).then((result) => {
    toast.success("HSN record updated successfully");
    return result;
  });

export const deleteSuperAdminHsn = (id) =>
  request("delete", `/${id}`).then((result) => {
    toast.success("HSN record deleted successfully");
    return result;
  });

export const getAllSuperAdminHsnGroups = (search = "") =>
  request("get", "/groups", undefined, { search });

export const getSuperAdminHsnGroup = (id) => request("get", `/groups/${id}`);

export const createSuperAdminHsnGroup = (data) =>
  request("post", "/groups", data).then((result) => {
    toast.success("HSN group created successfully");
    return result;
  });

export const updateSuperAdminHsnGroup = (id, data) =>
  request("put", `/groups/${id}`, data).then((result) => {
    toast.success("HSN group updated successfully");
    return result;
  });

export const deleteSuperAdminHsnGroup = (id) =>
  request("delete", `/groups/${id}`).then((result) => {
    toast.success("HSN group deleted successfully");
    return result;
  });
